
import './Landing.css';
import React from "react";
import flowershop from '../assets/images/flowershop.png'
import Footer from './Footer';

function Landing() {

    return (
        <div className="landing">
            <div className="openDoor">
                <a className="landingButton" href='/build'>
                    <h1 className="flowerShopButton"> click to step inside </h1>
                </a>
            </div>
            <img className="flowerShop" src={flowershop} alt="drawing of a virtual flowershop with a pink striped awning, green hedges out front, pink bouquets in the window, and an open sign lit up on the door."/>
            <Footer />
        </div>
    )
}

export default Landing;